export var StateTypes;

(function (StateTypes) {
  StateTypes["NONE"] = "NONE";
  StateTypes["FORM_VISIBLE"] = "FORM_VISIBLE";
  StateTypes["AWAIT_ACCOUNT"] = "AWAIT_ACCOUNT";
  StateTypes["AWAIT_LOGIN"] = "AWAIT_LOGIN";
})(StateTypes || (StateTypes = {}));

export var ErrorTypes;

(function (ErrorTypes) {
  ErrorTypes["USER_ALREADY_LOGGED_IN"] = "USER_ALREADY_LOGGED_IN";
  ErrorTypes["INVALID_STATE"] = "INVALID_STATE";
})(ErrorTypes || (ErrorTypes = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy50cyJdLCJuYW1lcyI6WyJTdGF0ZVR5cGVzIiwiRXJyb3JUeXBlcyJdLCJtYXBwaW5ncyI6IkFBQUEsV0FBWUEsVUFBWjs7V0FBWUEsVTtBQUFBQSxFQUFBQSxVO0FBQUFBLEVBQUFBLFU7QUFBQUEsRUFBQUEsVTtBQUFBQSxFQUFBQSxVO0dBQUFBLFUsS0FBQUEsVTs7QUFPWixXQUFZQyxVQUFaOztXQUFZQSxVO0FBQUFBLEVBQUFBLFU7QUFBQUEsRUFBQUEsVTtHQUFBQSxVLEtBQUFBLFUiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBTdGF0ZVR5cGVzIHtcbiAgTk9ORSA9ICdOT05FJyxcbiAgRk9STV9WSVNJQkxFID0gJ0ZPUk1fVklTSUJMRScsXG4gIEFXQUlUX0FDQ09VTlQgPSAnQVdBSVRfQUNDT1VOVCcsXG4gIEFXQUlUX0xPR0lOID0gJ0FXQUlUX0xPR0lOJyxcbn1cblxuZXhwb3J0IGVudW0gRXJyb3JUeXBlcyB7XG4gIFVTRVJfQUxSRUFEWV9MT0dHRURfSU4gPSAnVVNFUl9BTFJFQURZX0xPR0dFRF9JTicsXG4gIElOVkFMSURfU1RBVEUgPSAnSU5WQUxJRF9TVEFURScsXG59XG4iXX0=